import { queryOptions } from '@tanstack/react-query';
import { mutationOptions } from '../../common/utils';
import { orderAPIClient } from '../orderAPIClient';
import { ORDER_QUERY_KEYS } from './keys';
import type {
  GetCustomerOrderRequest,
  GetOrderByTrackingRequest,
  GetOrderRequest,
  GetOrdersRequest,
  GetUserOrdersRequest,
  AssociateOrderRequest,
  AssociateOrderResponse,
  EditShippingAddressRequest,
  EditShippingAddressResponse,
  EditBillingAddressRequest,
  EditBillingAddressResponse,
} from './types';

export const ORDER_QUERIES = {
  getOrder: (params: GetOrderRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrder(params),
      queryFn: () => orderAPIClient.getOrder(params),
      enabled: !!params.orderId,
      retry: false,
    });
  },

  getCustomerOrder: (params: GetCustomerOrderRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getCustomerOrder(params),
      queryFn: () => orderAPIClient.getCustomerOrder(params),
      enabled: !!params.orderId,
      retry: false,
    });
  },

  getOrders: (params?: GetOrdersRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrders(params),
      queryFn: () => orderAPIClient.getOrders(params),
    });
  },

  getUserOrders: (params: GetUserOrdersRequest = {}) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getUserOrders(params),
      queryFn: () => orderAPIClient.getUserOrders(params),
      retry: false,
    });
  },

  associateOrder: () =>
    mutationOptions<AssociateOrderResponse, unknown, AssociateOrderRequest>({
      mutationKey: ORDER_QUERY_KEYS.associateOrder(),
      mutationFn: (payload) => orderAPIClient.associateOrder(payload),
    }),

  editShippingAddress: () =>
    mutationOptions<EditShippingAddressResponse, unknown, EditShippingAddressRequest>({
      mutationKey: ORDER_QUERY_KEYS.editShippingAddress(),
      mutationFn: (payload) => orderAPIClient.editShippingAddress(payload),
    }),

  editBillingAddress: () =>
    mutationOptions<EditBillingAddressResponse, unknown, EditBillingAddressRequest>({
      mutationKey: ORDER_QUERY_KEYS.editBillingAddress(),
      mutationFn: (payload) => orderAPIClient.editBillingAddress(payload),
    }),

  getOrderByTracking: (params: GetOrderByTrackingRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrderByTracking(params),
      queryFn: () => orderAPIClient.getOrderByTracking(params),
      enabled: !!params.trackingNo,
      retry: false,
    });
  },
};
